<template>
  <div :id="`${source}_typing_text`" class="flex items-center gap-1">
    <span :class="textStyle">{{ text }}</span>

    <div class="flex items-center gap-[2px]">
      <span
        v-for="i in numberOfDots"
        :key="i"
        :class="['typing-dot', textStyle]"
        :style="{ animationDelay: `${(i - 1) * 0.2}s` }"
      >
        •
      </span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  source: { type: String, required: true },
  text: { type: String, default: "Loading" },
  textStyle: { type: String, default: "text-sm" },
  numberOfDots: { type: Number, default: 3 },
});
</script>

<style scoped>
.typing-dot {
  animation: typing-blink 1.4s infinite;
  opacity: 0;
}

@keyframes typing-blink {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
</style>
